export default __webpack_public_path__ + "static/media/armario-propagador-esquejes.814571f3.jpg";